module.exports = __webpack_public_path__ + "65afe1f1ffb9d9a23d25d2327ba2c3d3.svg";